<template>
  <ErrorBlock
    v-if="!error"
    :title="libraryBook.metaTitle"
    :description="description"
    :label="label"
    @click.capture="handleClick"
  />
  <ErrorBase v-else :error="error" />
</template>
<script setup lang="ts">
import { ErrorTypes, Eva2Error } from '~/lib/errors/Eva2Error';

import { getServices } from '~/db/services';

type Props = {
  slug: string;
};
const error = ref();

const { t } = useI18n();

const { $db } = useNuxtApp();

const props = defineProps({
  slug: null
});

const { libraryBooksService } = getServices($db);

const libraryBook = await libraryBooksService.get({ slug: props.slug });

const dialog = useDialogStore();

if (!libraryBook) {
  error.value = new Eva2Error(ErrorTypes.ContentNotFound);
}

const install = async () => {
  try {
    await useLibraryBooksAddToProfile([libraryBook.id]);
    dialog.close();
    forceReloadPath();
  } catch (e) {
    error.value = e;
  }
};

const forceReloadPath = () => {
  location.reload();
};

const handleClick = () => {
  install();
};

const description = computed(() => {
  return t('content.missing');
});
const label = computed(() => {
  return t('content.add');
});
</script>
